
/**
 * @export
 * @type SsoConnection
 */
export type SsoConnection = {
    ssoUrl: string;
    ssoCertificate: string;
    ssoMandatory: boolean;
    ssoEnabled: boolean;
    jitEnabled: boolean;
    domains: Array<string>;
    role: SsoConnectionRole;
    canUpdateSsoEnabled: boolean;
}

export enum SsoConnectionRole {
    STANDALONE = 'STANDALONE',
    PARENT = 'PARENT',
    CHILD = 'CHILD'
}